import { render } from "./A.vue?vue&type=template&id=39c9c2d1"
import script from "./A.vue?vue&type=script&lang=js"
export * from "./A.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__